<ng-container *ngIf="themeService.theme | async as currentTheme">
  <div (click)="onSwitchMode()" class="p-relative cont navbar-bg" [ngClass]="currentTheme">
    <div class="knob">
      <fa-icon [icon]="faMoon"></fa-icon>
    </div>
  </div>
</ng-container>